import { render, staticRenderFns } from "./CataloguesList.vue?vue&type=template&id=10d889c4&scoped=true&"
import script from "./CataloguesList.vue?vue&type=script&lang=js&"
export * from "./CataloguesList.vue?vue&type=script&lang=js&"
import style0 from "./CataloguesList.vue?vue&type=style&index=0&id=10d889c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d889c4",
  null
  
)

export default component.exports